<template>
  <div class="main-box">
    <b-row align-h="between">
      <b-col sm="8" order="1">
        <contact />
      </b-col>
      <b-col sm="4" order="2">
        <!-- <help-line /> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
  //  import HelpLine from '@/components/help/HelpLine.vue'
  import Contact from '@/components/help/Contact.vue'

  export default {
    components: {
      /* HelpLine, */
      Contact
    }
  }
</script>
